import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function SendSMSButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      Send SMS
    </Button>
  );
}
